import { render, staticRenderFns } from "./PrizeRequestDetails.vue?vue&type=template&id=646493ec&scoped=true&"
import script from "./PrizeRequestDetails.vue?vue&type=script&lang=js&"
export * from "./PrizeRequestDetails.vue?vue&type=script&lang=js&"
import style0 from "./PrizeRequestDetails.vue?vue&type=style&index=0&id=646493ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646493ec",
  null
  
)

export default component.exports